import { FormGroup, UntypedFormGroup, Validators } from '@angular/forms';

/* eslint-disable */
export const EmailValidationPattern: string =
  "^[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$";
export const OrganizationUnitDisallowedCharacters: string = '^=\\#";,+';

export const OrganizationUnitValidationPattern: string = '[' + OrganizationUnitDisallowedCharacters + ']*';
/* eslint-enable */

export const setFormControlEnabled = (form: FormGroup, formControlName: string, isEnabled: boolean): void => {
  const control = form.get(formControlName);
  if (!control) {
    console.warn(`FormControlName ${formControlName} was not found.`);
    return;
  }

  if (isEnabled && !control.enabled) {
    control.enable();
  }

  if (!isEnabled && control.enabled) {
    control.disable();
  }
};

export function patternNoPlusInNameValidator() {
  return Validators.pattern('[^\\+]+');
}
